import { COUNTRIES } from './environment';

export const PATHS = {
  store: {
    [COUNTRIES.pt]: '/lojas/',
    default: '/locales/'
  },
  home: { default: '/' }
};
